import React, { useEffect, useRef } from 'react';

const AnimatedFigure = ({
  image,
  style = {},
  animationOptions = {},
  timelines,
  setTimelines,
  indexOfElem,
  indexOfArray,
  lengthOfArray,
}) => {
  const elem = useRef();

  useEffect(() => {
    if (
      timelines?.[indexOfArray]?.enter &&
      !timelines?.[indexOfArray]?.isReady
    ) {
      const enterAnimation = {
        targets: elem.current,
        opacity: 1,
        scale: 1,
        duration: 1000,
        ...animationOptions,
      };
      const newTimelines = timelines.map((t, i) => {
        if (i === indexOfArray) {
          const offset = indexOfElem === 0 ? 0 : '-=900';
          t.enter.add(enterAnimation, offset);
          return { ...t, isReady: true };
        }
        return t;
      });
      if (indexOfElem === lengthOfArray - 1) setTimelines(newTimelines);
    }
  }, [timelines, animationOptions, indexOfArray, indexOfElem]);

  return (
    <figure
      style={{
        position: 'absolute',
        opacity: 0,
        overflow: 'hidden',
        transform: 'scale(0)',
        willChange: 'transform, opacity',
        ...style,
      }}
      ref={elem}
    >
      <img src={image} alt="Animated figure" loading="lazy" />
    </figure>
  );
};

export default AnimatedFigure;
